import { TextProps } from "antd/es/typography/Text";
import { ParagraphProps } from "antd/lib/typography/Paragraph";
import { ReactNode } from "react";

export enum EFontWeights {
	REGULAR = "normal",
	MEDIUM = "medium",
	SEMIBOLD = "semibold"
}

export interface ITypographyProps extends TextProps {
	level?: number;
	weight?: EFontWeights;
	className?: string;
	color?: string;
	colorVariant?: number;
	capitalise?: boolean;
	children: string | ReactNode;
	disabled?: boolean;
}

export interface IParagraphProps extends ParagraphProps {
	level?: number;
	weight?: EFontWeights;
	className?: string;
	color?: string;
	colorVariant?: number;
	capitalise?: boolean;
	children: string | ReactNode;
	disabled?: boolean;
	collapsible?: boolean;
}
